/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Emoji_MisprintInputs */



/**
* | output |
* | --- |
* | "[MISPRINT]" |
*
* @param {Error_Emoji_MisprintInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_emoji_misprint = /** @type {((inputs?: Error_Emoji_MisprintInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Emoji_MisprintInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("[FEHLDRUCK]")
	if (locale === "fr") return /** @type {LocalizedString} */ ("[ERREUR D'IMPRESSION]")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("[错印]")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("[誤印]")
	if (locale === "ko") return /** @type {LocalizedString} */ ("[인쇄 오류]")
	return /** @type {LocalizedString} */ ("[MISPRINT]")
});